import { useClickAway, useMedia } from 'react-use'
import styled from 'styled-components'
import React, { useRef, useState } from 'react'
import { ScreenDefault } from '.'

const Wrapper = styled.aside<{ $isMobile: boolean; $isOpen: boolean }>`
  position: ${({ $isMobile }) => ($isMobile ? 'relative' : 'absolute')};
  margin-top: ${({ $isMobile }) => ($isMobile ? '0' : '90px')};
  ${({ $isMobile }) => ($isMobile ? `left: 0px;` : '')}
  ${({ $isMobile }) => ($isMobile ? `bottom: 0px;` : 'top: 0px;')}

  .layer {
    background-color: white;
    width: ${({ $isMobile }) => ($isMobile ? '80vw' : '20vw')};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadow(1)};

    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background-color: ${({ theme }) => theme.backdropBackground};
      -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
      backdrop-filter: ${({ theme }) => theme.backdropFilter};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
      overflow: hidden;
      transform: translateY(${({ $isOpen }) => ($isOpen ? '0' : '30%')});
      visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
      transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out, visibility 0.3s ease-in-out;
      max-width: 300px;

      position: absolute;
      left: calc(40px + ${({ theme }) => theme.padding(0.3)});
      bottom: 0px;
    }
  }
`

type BaseListProps = {
  children: React.ReactNode
}

export const BaseList = ({ children }: BaseListProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const ref = useRef(null)
  const isMobile = useMedia(`(max-width: 768px)`)

  useClickAway(ref, () => {
    if (isMobile && isOpen) {
      setIsOpen(prevData => !prevData)
    }
  })

  return (
    <Wrapper ref={ref} $isOpen={isOpen} $isMobile={isMobile}>
      {isMobile && (
        <ScreenDefault.Button isOpen={isOpen} onClick={e => setIsOpen(prevData => !prevData)} />
      )}
      <main className='layer'>{children}</main>
    </Wrapper>
  )
}
